import moment from 'moment';
import { EMeasureUnit } from '../../../../../store/commomTypes';
import { IMeasureUnit } from '../../../../../store/ducks/long-steel-shopping-cart/types';

// MeasureUnit
export const isSelectedAnInvalidMeasureUnit = (
  selected?: IMeasureUnit | undefined,
  itemMeasureUnit?: EMeasureUnit | string
) => {
  return !selected && itemMeasureUnit !== undefined && itemMeasureUnit !== '';
};

// QuantityInput
export const isInvalidMultipleValue = (
  measureUnit: IMeasureUnit,
  value: string
) => {
  return (
    parseFloat(value) > 0 &&
    Math.round(parseFloat(value) * 1000) %
      Math.round(parseFloat(measureUnit.multiple) * 1000) !==
      0
  );
};

export const isLoweThanMinimumQty = (
  measureUnit: IMeasureUnit,
  value: string
) => {
  return (
    parseFloat(value) > 0 &&
    parseFloat(value) < parseFloat(measureUnit.minimumQuantity)
  );
};
//

// DateInput
export const isOutOfMinimunDate = (minimumDate: string, value?: string) => {
  const desiredDate = moment(value, 'YYYY-MM-DD');
  const minimunDate = moment(minimumDate, 'YYYY-MM-DD');
  return value !== '' && desiredDate.isBefore(minimunDate);
};

export const isWeekend = (date: moment.Moment): boolean => {
  return (
    date.day() === 6 || // sábado
    date.day() === 0
  ); // domingo;
};

export const separateTermsWithPunctuation = (
  index: number,
  arrLength: number,
  finalPunctuation: string
): string => {
  if (index + 1 === arrLength - 1) {
    return ' e ';
  }
  return index + 1 >= arrLength ? finalPunctuation : ', ';
};

export const convertInputedValue = (
  inputValue: string,
  unit: IMeasureUnit,
  lastUnit: string | undefined
): string => {
  if (unit.measure === lastUnit) {
    return inputValue;
  }
  const fValue = parseFloat(inputValue);
  if (unit.measure === EMeasureUnit.KG && parseFloat(unit.multiple) > 0) {
    return (fValue * 1000).toString();
  }
  if (unit.measure === EMeasureUnit.T && parseFloat(unit.multiple) > 0) {
    return (fValue / 1000).toString();
  }
  return '';
};

export const areMeasuresConvertible = (
  convertibleMeasures: EMeasureUnit[],
  currentMeasure: EMeasureUnit,
  targetMeasure: EMeasureUnit
): boolean => {
  return (
    convertibleMeasures.includes(currentMeasure) &&
    convertibleMeasures.includes(targetMeasure)
  );
};
